/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Market } from '../model/market';
import { environment } from '../../../environments/environment';

@Injectable()
export class MarketService {
  // private marketurl: string = environment.host + '/company/';
  private regionurl: string = environment.host + '/market/';
  private getMarketURL: string = environment.host + '/market/';
  private getallregionsurl: string = environment.host + '/region';
  private getallregionsandplansurl: string = environment.host + '/region/plans';
  /* New url are added here*/
  private marketurl: string = environment.host + '/market';
  private marketsurl: string = environment.host + '/markets';
  private url: string = environment.host + '/company?tabType=' + 'MR';

  constructor(private http: HttpClient) {}

  /* Latest url constructs are listed here */
  public getAllMarkets() {
    const URL=this.marketurl+'?tabType=marketsregions';
    return this.http.get(URL.toString()).toPromise();
  }
  /* Latest url constructs are listed here */

  public createMarket(marketObj: Market) {
    return this.http.post(this.marketurl.toString(), marketObj).toPromise();
  }

  public updateMarket(marketObj: Market) {
    return this.http.put(this.marketurl.toString(), marketObj).toPromise();
  }

  public deleteMarket(marketObj: Market) {
    return this.http.delete(this.marketurl.toString() + '/' + marketObj.id).toPromise();
  }

  public getAllMarketsByCompanyId(companyId: any) {
    return this.http.get(this.marketurl.toString()).toPromise();
  }

  public getAllRegions() {
    return this.http.get(this.getallregionsurl.toString()).toPromise();
  }

  public getAllRegionsAndPlans() {
    return this.http.get(this.getallregionsandplansurl.toString()).toPromise();
  }

  public createUpdateMarkets(marketsData: any) {
    return this.http.post(this.marketsurl.toString(), marketsData).toPromise();
  }

  public getAllCompanies() {
    return this.http.get(this.url.toString()).toPromise();
  }

  /*
   createRegion(markettId: number, newRegionObj: Region) {
     return this.http.post(this.regionurl.toString() + markettId + '/region', newRegionObj).toPromise();
   }
  
   getAllMarketsByCompanyId(companyId) {
     return this.http.get(this.marketurl.toString()).toPromise();
   }
   /*
    createRegion(markettId: number, newRegionObj: Region) {
      return this.http.post(this.regionurl.toString() + markettId + '/region', newRegionObj).toPromise();
    }
    
    viewMarketDetails(marketObj: Market) {
      return this.http.get(this.getMarketURL.toString() + marketObj.id).toPromise();
    }
    
    updateRegion(marketId: number, regionObj: Region) {
      return this.http.put(this.regionurl.toString() + marketId + '/region', regionObj).toPromise();
    }
    
    deleteRegion(regionId: number) {
      return this.http.delete(this.getallregionsurl.toString() + '\\' + regionId).toPromise();
    }*/
}